<template>
    <div class="flex items-center space-x-5">
        <div class="flex flex-col space-y-1">
            <span class="text-gray-500">{{ period }}</span>
            <typography variant="h4" class="text-gray-900  dark:text-gray-400">{{ parsedNumber }}{{ unit }}</typography>
            <span class="text-gray-500">{{ label }}</span>
        </div>

        <progress-indicator :type="progress"/>
    </div>
</template>

<script>
export default {
    name: "StatBox",
    props: {
        period: {
            type: String,
            default: "Last 24h"
        },
        number: {
            type: Number
        },
        unit: {
            type: String,
            required: false
        },
        label: {
            type: String,
            default: ""
        },
        progress: {
            type: String,
            default: "neutral"
        }
    },
    computed: {
        parsedNumber () {
            return this.number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
}
</script>